export const fillStackedData = (data, selectorOuter, selectorInner, value) => {
  data[selectorOuter] = {
    ...(data[selectorOuter] || {}),
    [selectorInner]: ((data[selectorOuter] || {})[selectorInner] || 0) + value,
  };
};
